const appConfig: { version: string; appName: string } = {
  version: "1.0.2",
  appName: "event-service-app"
};

export default appConfig;
